module.exports = __webpack_public_path__ + "img/3.0521442f.jpg";